import { render, staticRenderFns } from "./termRedeemModal.vue?vue&type=template&id=320ef2b9&scoped=true"
import script from "./termRedeemModal.vue?vue&type=script&lang=js"
export * from "./termRedeemModal.vue?vue&type=script&lang=js"
import style0 from "./termRedeemModal.vue?vue&type=style&index=0&id=320ef2b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320ef2b9",
  null
  
)

export default component.exports